<template>
  <v-toolbar
    height="50"
    class="app-header-wrapper"
  >
    <v-container fluid>
      <v-row justify="space-between" align="center">
        <v-col cols="auto">
          <v-row justify="space-between" align="center">
            <div class="app-header-logo" />
            <HeaderLogo :text="$t('about.iot_connected_platform').toUpperCase()" />
            <About />
          </v-row>
        </v-col>
        <v-col cols="auto" style="display:inline-flex;">
          <MasterComponent v-if="getCurrentUserName" />
          <Avatar />
        </v-col>
      </v-row>
    </v-container>
  </v-toolbar>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import useStore from '@/utils/store/common';
import Avatar from '@/components/common/Avatar/Avatar.vue';
import MasterComponent from '@/components/common/MasterComponent/MasterComponent.vue';
import About from './components/About/About.vue';
import HeaderLogo from './components/HeaderLogo.vue';

const store = useStore();
const getCurrentUserName = computed(() => store.getters['user/getCurrentUserName']);
</script>
<style lang="scss" scoped>
@import './styles/application-header.scss';
</style>
